import { Link } from "react-router-dom";

export function InvalidType({ userType }: { userType: string }) {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
            <div className="text-center p-8 max-w-md">
                <i className="ri-error-warning-line text-5xl text-red-400 mb-4 block" />
                <h1 className="text-2xl font-bold text-gray-900 mb-2">Type d'inscription inconnu</h1>
                <p className="text-gray-500 mb-6">
                    <code className="bg-gray-100 px-2 py-1 rounded text-sm">{userType}</code> n'existe pas.
                </p>
                <Link to="/" className="px-6 py-3 bg-teal-600 text-white rounded-lg hover:bg-teal-700 font-medium">
                    Retour à l'accueil
                </Link>
            </div>
        </div>
    );
}